import React, { useEffect } from "react";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
  useRouteError,
} from "react-router-dom";
import { prestationsRouteur } from "./PrestationsRoutes";
import { interpretesRouter } from "./InterpretesRoutes";
import { routerGhost } from "./GhostRoutes";
import { routerMainLayout } from "./MainLayoutRoutes";
import { institutionRouter } from "./InstitutionsRoutes";
import { principalRouter } from "./PrincipalsRoutes";
import { billingRouter } from "./BillingRoutes";
import { ErrorElement, Fallback } from "../ErrorReportingBoundary";
import { usersRoutes } from "./UsersRoutes";
import DynamicHelmet from "../../layouts/MainLayout/DynamicHelmet";

export const router = createBrowserRouter([
  {
    element: <DynamicHelmet />,
    errorElement: <ErrorElement />,
    children: [
      routerMainLayout,
      ...prestationsRouteur,
      ...billingRouter,
      ...institutionRouter,
      ...interpretesRouter,
      ...principalRouter,
      ...usersRoutes,
      ...routerGhost,
      {
        path: "*",
        errorElement: <p>ff</p>,
        element: <Navigate to="/" />,
      },
    ],
  },
]);
export default function AppRouter(props) {
  return <RouterProvider router={router} />;
}
